import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function SyllabusPhy() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="physics" type="syllabus" book="" />

    </>
  );
}

export default SyllabusPhy;